/**
 * Running total on the Add to cart button.
 *
 * Reads the unit price from the button, multiplies by the quantity input, adds
 * any checked "Frequently bought together" items, and follows variant switches
 * through the theme's own `variantChange` event — the same hook
 * price-per-item.js uses — rather than scraping rendered markup.
 *
 * Bundle items belong in this total because product-form.js posts them with the
 * main item as a single `items[]` payload, each at quantity 1, so the button
 * really does add them.
 *
 * Fails closed: if the price or quantity can't be resolved the total is hidden
 * rather than shown stale. A wrong number on this button is worse than none.
 */
(function () {
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return null;
    }
  }

  function wire(button) {
    if (!button || button.dataset.atcTotalBound === 'true') return;
    button.dataset.atcTotalBound = 'true';

    var totalEl = button.querySelector('[data-atc-total]');
    if (!totalEl) return;

    var form = button.closest('form') || button.closest('product-form');
    var section = button.closest('[data-section]');
    var qtyInput = section && section.querySelector('.quantity__input');
    var unit = parseInt(button.dataset.atcUnit, 10);
    var currency = button.dataset.atcCurrency;

    /* Checked add-ons, each at quantity 1 — matching the payload product-form.js
       builds. Returns null if any price can't be parsed, so a broken data
       attribute hides the total instead of under-reporting it. */
    function addonsCents() {
      var boxes = document.querySelectorAll('.bundle-checkbox__input:checked');
      var sum = 0;
      for (var i = 0; i < boxes.length; i++) {
        var cents = parseInt(boxes[i].dataset.price, 10);
        if (!Number.isFinite(cents)) return null;
        sum += cents;
      }
      return sum;
    }

    function render() {
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!qty || qty < 1) qty = 1;

      if (!Number.isFinite(unit) || unit <= 0) {
        totalEl.hidden = true;
        return;
      }
      var addons = addonsCents();
      if (addons === null) {
        totalEl.hidden = true;
        return;
      }
      var text = money(unit * qty + addons, currency);
      if (!text) {
        totalEl.hidden = true;
        return;
      }
      totalEl.textContent = text;
      totalEl.hidden = false;
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', render);
      qtyInput.addEventListener('input', render);
    }
    /* the +/- buttons write to the input programmatically, so catch the click too */
    if (section) {
      section.addEventListener('click', function (e) {
        if (e.target.closest('.quantity__button')) setTimeout(render, 0);
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var v = event && event.data && event.data.variant;
        if (!v) { totalEl.hidden = true; return; }
        unit = parseInt(v.price, 10);
        render();
      });
      if (PUB_SUB_EVENTS.quantityUpdate) {
        subscribe(PUB_SUB_EVENTS.quantityUpdate, render);
      }
      /* product-bundle.liquid clears the checkboxes after a successful add by
         setting .checked directly, which fires no change event — so recompute
         from the cart update instead. */
      if (PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(render, 0); });
      }
    }

    /* delegated, because the bundle block may render after this runs */
    document.addEventListener('change', function (e) {
      if (e.target.classList && e.target.classList.contains('bundle-checkbox__input')) render();
    });

    render();
  }

  function init() {
    document.querySelectorAll('.product-form__submit[data-atc-unit]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
